/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsSquareCirclePlusTriangleFill: {
  name: 'square-circle-plus-triangle-fill';
  data: string;
} = {
  name: 'square-circle-plus-triangle-fill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm4 8a1 1 0 0 1 .894.553l3 6A1 1 0 0 1 10 21H4a1 1 0 0 1-.894-1.447l3-6A1 1 0 0 1 7 13Zm11 1a1 1 0 1 0-2 0v2h-2a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2v-2Zm-5-7a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z" fill="currentColor"/></svg>`,
};
